jQuery(document).ready(function ($) {

    if ($('.category-list').length > 0) {
        document.querySelectorAll('.category-list input').forEach((el) => {
            if (el.value) {
                $('[data-id="' + el.value + '"]').removeClass('dynamic-item');
            }
        })
    }

    if ($(".filter-block__components li a.active").length > 0) {
        let activeEl = $(".filter-block__components li a.active");
        activeEl.parent().addClass("active-element");
        let amountExtraShown = 2;
        let elementsBefore = $(".active-element").prevAll("li");
        let elementsAfter = $(".active-element").nextAll("li:not(#list-see-more)");

        $(".filter-block__components li").removeClass("hidden-item");

        let modTop = amountExtraShown;
        let modBot = amountExtraShown;

        if (elementsBefore.length < amountExtraShown) {
            modBot = elementsBefore.length;
        }
        if (elementsAfter.length < amountExtraShown) {
            modTop = elementsAfter.length;
        }

        let i = 0;
        for (let el of elementsBefore) {
            i++;
            if (i > (4 - modTop)) {
                $(el).addClass("hidden-item");
            }
        }

        let j = 0;
        for (let el of elementsAfter) {
            j++;
            if (j > (4 - modBot)) {
                $(el).addClass("hidden-item");
            }
        }
    }

    $('#list-see-more').on("click", () => {
        let filterCat = $(".filter-block__components");

        filterCat.toggleClass("show-all-elements");

        $('#list-see-more').html($('#list-see-more').attr(filterCat.hasClass("show-all-elements") ? "data-text-less" : "data-text-more"));
    });
});
